module.exports = VueViewer;